const bMediaItemFile = {
    props: {
        card: {
            type: Object,
            default() {
                return null;
            },
        }
    },
    template: 
    `<a :href="card.url" target="_blank" class="b-media-item--file">
        <div v-if="card.title && card.title !==''" class="b-media-item__title" v-html="card.title"></div>
        <div v-if="card.desc && card.desc !==''" class="b-media-item__desc" v-html="card.desc"></div>
        <div v-if="card.url && card.url !==''" class="b-media-item__cta">
            <span class="e-arrow e-arrow--down"></span>
        </div>
    </a>`

}